/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type FunidngRecordPaginatedProperty =
  typeof FunidngRecordPaginatedProperty[keyof typeof FunidngRecordPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FunidngRecordPaginatedProperty = {
  OWNER_NAME: 'OWNER_NAME',
  PARTNER_TYPE: 'PARTNER_TYPE',
  VALUE_AMOUNT: 'VALUE_AMOUNT',
  VALUE_CURRENCY: 'VALUE_CURRENCY',
  PAYMENT_DIRECTION: 'PAYMENT_DIRECTION',
  CREATED_AT: 'CREATED_AT',
  UPDATED_AT: 'UPDATED_AT',
  SERVICE_TYPE: 'SERVICE_TYPE',
} as const;
